/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  FilterOptionsList,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Trade Route Commodity Filters
 */
export const tradeRouteCommoditiesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/trade-routes/commodities`, method: 'GET', signal
    },
      );
    }




export const getTradeRouteCommoditiesFiltersQueryKey = () => {
    return [
    'filters','trade-routes','commodities'
    ] as const;
    }


export const getTradeRouteCommoditiesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof tradeRouteCommoditiesFilters>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRouteCommoditiesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTradeRouteCommoditiesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeRouteCommoditiesFilters>>> = ({ signal }) => tradeRouteCommoditiesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeRouteCommoditiesFilters>>, TError, TData>
}

export type TradeRouteCommoditiesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof tradeRouteCommoditiesFilters>>>
export type TradeRouteCommoditiesFiltersQueryError = ErrorType<StandardError>


/**
 * @summary Trade Route Commodity Filters
 */

export function useTradeRouteCommoditiesFilters<TData = Awaited<ReturnType<typeof tradeRouteCommoditiesFilters>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRouteCommoditiesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTradeRouteCommoditiesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Trade Route Star System Filters
 */
export const tradeRouteStarSystemsFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/trade-routes/star-systems`, method: 'GET', signal
    },
      );
    }




export const getTradeRouteStarSystemsFiltersQueryKey = () => {
    return [
    'filters','trade-routes','star-systems'
    ] as const;
    }


export const getTradeRouteStarSystemsFiltersQueryOptions = <TData = Awaited<ReturnType<typeof tradeRouteStarSystemsFilters>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRouteStarSystemsFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTradeRouteStarSystemsFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeRouteStarSystemsFilters>>> = ({ signal }) => tradeRouteStarSystemsFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeRouteStarSystemsFilters>>, TError, TData>
}

export type TradeRouteStarSystemsFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof tradeRouteStarSystemsFilters>>>
export type TradeRouteStarSystemsFiltersQueryError = ErrorType<StandardError>


/**
 * @summary Trade Route Star System Filters
 */

export function useTradeRouteStarSystemsFilters<TData = Awaited<ReturnType<typeof tradeRouteStarSystemsFilters>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRouteStarSystemsFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTradeRouteStarSystemsFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Trade Route Terminal Filters
 */
export const tradeRouteTerminalsFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/trade-routes/terminals`, method: 'GET', signal
    },
      );
    }




export const getTradeRouteTerminalsFiltersQueryKey = () => {
    return [
    'filters','trade-routes','terminals'
    ] as const;
    }


export const getTradeRouteTerminalsFiltersQueryOptions = <TData = Awaited<ReturnType<typeof tradeRouteTerminalsFilters>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRouteTerminalsFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTradeRouteTerminalsFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeRouteTerminalsFilters>>> = ({ signal }) => tradeRouteTerminalsFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeRouteTerminalsFilters>>, TError, TData>
}

export type TradeRouteTerminalsFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof tradeRouteTerminalsFilters>>>
export type TradeRouteTerminalsFiltersQueryError = ErrorType<StandardError>


/**
 * @summary Trade Route Terminal Filters
 */

export function useTradeRouteTerminalsFilters<TData = Awaited<ReturnType<typeof tradeRouteTerminalsFilters>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRouteTerminalsFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTradeRouteTerminalsFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






